import { v4 as uuid } from 'uuid';
import './ModelTestStyle.scss';
import { ActionFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/ActionFeatures';
const DEFAULT_PROVIDER_NOT_DEFINED_CODE_ERROR = 1233;
const TRAINING_IN_PROGRESS_CODE_ERROR = 1214;
const MODEL_NOT_FOUND_CODE_ERROR = 1213;
const DEFAULT_PROVIDER_NOT_DEFINED_ERROR = 'ai-publication.testSidbar.errors.defaultProviderNotDefined';
const TRAINING_IN_PROGRESS_ERROR = 'ai-publication.testSidbar.errors.trainingInProgress';
const MODEL_NOT_FOUND_ERROR = 'ai-publication.testSidbar.errors.modelNotFound';
const GENERIC_ERROR = 'ai-publication.testSidbar.errors.generic';
const MESSAGE_AREA_PLACEHOLDER = 'ai-publication.testSidbar.testPlaceholderMessage';
const INTENTS_INPUT_LABEL = 'ai-publication.testSidbar.testIntentionLabel';
const ENTITIES_INPUT_LABEL = 'ai-publication.testSidbar.testEntityLabel';
const CONTENTS_INPUT_LABEL = 'ai-publication.testSidbar.testContentLabel';
const OPEN_STATUS_SUCCESS_TRACKING = 'ai-nlp-testmodel-click-success';
const OPEN_STATUS_FAILED_TRACKING = 'ai-nlp-testmodel-click-fail';
const ANALYSE_CONTENT_SUCCESS_TRACKING = 'ai-nlp-publication-model-testwindow-testsent';
const ANALYSE_CONTENT_FAILED_TRACKING = 'ai-nlp-publication-model-testwindow-testsent';
const INTENT_LIST_TRACKING = 'ai-nlp-publication-model-testwindow-testanalysis-intent-listed';
const INTENT_UNLIST_TRACKING = 'ai-nlp-publication-model-testwindow-testanalysis-intent-listed';
const ENTITY_LIST_TRACKING = 'ai-nlp-publication-model-testwindow-testanalysis-entity-listed';
const ENTITY_UNLIST_TRACKING = 'ai-nlp-publication-model-testwindow-testanalysis-entity-listed';
export class ModelTestController {
    static $inject = ['close', '$translate', 'SegmentService', 'AccountService2', 'MessagingHubService', 'CurrentApplicationService', 'ngToast', 'ArtificialIntellingeceConfigurationsService'];
    constructor(close, $translate, SegmentService, AccountService2, MessagingHubService, CurrentApplicationService, ngToast, ArtificialIntellingeceConfigurationsService) {
        'ngInject';
        this.close = close;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.AccountService2 = AccountService2;
        this.MessagingHubService = MessagingHubService;
        this.CurrentApplicationService = CurrentApplicationService;
        this.ngToast = ngToast;
        this.ArtificialIntellingeceConfigurationsService = ArtificialIntellingeceConfigurationsService;
        this.analyses = [];
        this.tagValues = [];
        this.optionSelect = [];
        this.V2Enabled = false;
        this.canSendMessage = false;
        this.isConfigurationsApplicationGetEnabled = false;
        this.onChangeItem = (event) => {
            const { detail: { data } } = event;
            this.optionSelect = data;
        };
        this.onEntityToggle = (toggle) => {
            this.SegmentService.createApplicationTrack({ trackEvent: toggle ? ENTITY_LIST_TRACKING : ENTITY_UNLIST_TRACKING });
        };
        this.onIntentFocus = () => {
            this.SegmentService.createApplicationTrack({ trackEvent: INTENT_LIST_TRACKING });
        };
        this.onIntentBlur = () => {
            this.SegmentService.createApplicationTrack({ trackEvent: INTENT_UNLIST_TRACKING });
        };
        this.init();
    }
    async init() {
        this.isConfigurationsApplicationGetEnabled = await ActionFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
        this.application = await this.CurrentApplicationService.fetchApplication();
        await this.checkModelStatus();
        this.V2Enabled = (await this.isContentAssistantV2Enabled()) == true;
        if (this.V2Enabled) {
            const result = await this.getTags();
            (result.items || []).forEach(item => {
                item.values.reduce((values, value) => values.concat(value.synonymous.map(v => {
                    const newtag = { label: v, value: v };
                    this.tagValues.push(newtag);
                })), []);
            });
        }
        this.placeholder = await this.$translate(MESSAGE_AREA_PLACEHOLDER);
        this.intentsLabel = await this.$translate(INTENTS_INPUT_LABEL);
        this.entitiesLabel = await this.$translate(ENTITIES_INPUT_LABEL);
        this.contentsLabel = await this.$translate(CONTENTS_INPUT_LABEL);
        this.intentions = await this.getIntents();
        this.entities = await this.getEntities();
    }
    async checkModelStatus() {
        this.model = await this.getLastModel();
        if (this.model) {
            this.canSendMessage = true;
            this.SegmentService.createApplicationTrack({ trackEvent: OPEN_STATUS_SUCCESS_TRACKING });
        }
        else {
            this.SegmentService.createApplicationTrack({ trackEvent: OPEN_STATUS_FAILED_TRACKING });
            this.close();
        }
    }
    async openFilterTag() {
        const modalElement = document.getElementById('card-filter');
        if (modalElement.style.display == 'none') {
            modalElement.style.display = 'block';
            modalElement.style.opacity = '1';
        }
        else {
            modalElement.style.display = 'none';
            modalElement.style.opacity = '0';
        }
    }
    async messageSubmit(content) {
        const currentUser = await this.AccountService2.me();
        this.analyses = this.analyses.concat({
            id: uuid(),
            content: content,
            promise: new Promise(async (resolve, reject) => {
                try {
                    const analyses = await this.MessagingHubService.ArtificialIntelligence
                        .analyse({
                        text: content,
                        testingRequest: true,
                        modelId: this.model.id,
                        extras: {
                            UserIdentity: currentUser.identity,
                        },
                    });
                    const entities = analyses.entities.map(e => e.value);
                    const intent = analyses.intentions[0].id;
                    let result = {};
                    const resource = {
                        Intent: intent,
                        Entities: entities,
                        MinEntityMatch: entities.length,
                        results: [
                            {
                                tags: (this.optionSelect ?? []),
                            },
                        ],
                    };
                    if (await this.isContentAssistantV2Enabled()) {
                        result = await this.getContentByCombination(resource);
                        if (result?.guid) {
                            analyses.content = result;
                        }
                    }
                    else {
                        result = await this.MessagingHubService.ArtificialIntelligence
                            .matchContent(resource);
                        analyses.content = result;
                    }
                    this.SegmentService.createApplicationTrack({ trackEvent: ANALYSE_CONTENT_SUCCESS_TRACKING });
                    resolve(analyses);
                }
                catch {
                    this.SegmentService.createApplicationTrack({ trackEvent: ANALYSE_CONTENT_FAILED_TRACKING });
                    reject();
                }
            }),
        });
    }
    async getLastModel() {
        try {
            const lastTrainedOrPublishedModel = await this.MessagingHubService.ArtificialIntelligence.getLastTrainedOrPublishedModel();
            return lastTrainedOrPublishedModel;
        }
        catch (e) {
            const exeptionMessage = JSON.parse(e.message);
            let errorMessage;
            switch (exeptionMessage.reason.code) {
                case DEFAULT_PROVIDER_NOT_DEFINED_CODE_ERROR:
                    errorMessage = DEFAULT_PROVIDER_NOT_DEFINED_ERROR;
                    break;
                case MODEL_NOT_FOUND_CODE_ERROR:
                    errorMessage = MODEL_NOT_FOUND_ERROR;
                    break;
                case TRAINING_IN_PROGRESS_CODE_ERROR:
                    errorMessage = TRAINING_IN_PROGRESS_ERROR;
                    break;
                default:
                    errorMessage = GENERIC_ERROR;
                    break;
            }
            await this.displayErrorMessage(errorMessage);
        }
    }
    async onModelError(id) {
        await this.displayErrorMessage(GENERIC_ERROR);
        this.analyses = this.analyses.filter(a => a.id !== id);
    }
    async getIntents() {
        return await this.MessagingHubService.ArtificialIntelligence.getIntents();
    }
    async isContentAssistantV2Enabled() {
        return await this.ArtificialIntellingeceConfigurationsService.isV2ConfigurationEnabled(this.isConfigurationsApplicationGetEnabled);
    }
    async getEntities() {
        return await this.MessagingHubService.ArtificialIntelligence.getEntities();
    }
    async displayErrorMessage(errorMessage) {
        const modelError = await this.$translate(errorMessage);
        this.ngToast.warning(modelError);
    }
    async getContentByCombination(combination) {
        try {
            return await this.MessagingHubService.sendCommand({
                method: 'set',
                uri: '/assistant/analysis',
                resource: combination,
                to: 'postmaster@ai.msging.net',
                type: 'application/vnd.iris.ai.content-combination+json',
            });
        }
        catch (e) {
            if (e.code == 67) {
                return;
            }
        }
    }
    async getTags() {
        try {
            return await this.MessagingHubService.sendCommand({
                method: 'get',
                uri: '/content-tags?$take=100',
                to: 'postmaster@ai.msging.net',
            });
        }
        catch (e) {
            if (e.code == 67) {
                return;
            }
        }
    }
}
ModelTestController.$inject = ['close', '$translate', 'SegmentService', 'AccountService2', 'MessagingHubService', 'CurrentApplicationService', 'ngToast', 'ArtificialIntellingeceConfigurationsService'];
